<template>
  <div class="pt-3">
    <div
      v-if="
        !trackedBill.IsSummary &&
        trackedBill.TrackedBillAgencies.findIndex(
          (a) => a.AgencyID == 2 && a.TrackedBillPermissionID == 1
        ) != -1
      "
      ><span class="sectionDescription">Position: </span
      ><span v-if="trackedBill.PositionID">
        <span
          v-if="trackedBill.Position"
          class="sectionText"
          :class="trackedBill.Position.Description.toLowerCase()"
          style="font-weight: bold"
          >{{ trackedBill.Position.Description }}</span
        >
      </span>
      <span v-else>Not Evaluated</span></div
    >
    <div
      ><span class="sectionDescription">Priority: </span>
      <span v-if="trackedBill.PriorityID">
        <span
          v-if="trackedBill.Priority"
          class="sectionText"
          :class="trackedBill.Priority.Description.toLowerCase()"
          style="font-weight: bold"
          >{{ trackedBill.Priority.Description }}</span
        >
      </span>
      <span v-else>Not Evaluated</span></div
    >
    <div
      ><span class="sectionDescription">Concerns: </span>
      <span v-if="trackedBill.ConcernID">
        <span
          v-if="trackedBill.Concern"
          class="sectionText"
          :class="trackedBill.Concern.Description.toLowerCase()"
          style="font-weight: bold"
          >{{ trackedBill.Concern.Description }}</span
        >
      </span>
      <span v-else>Not Evaluated</span></div
    >
    <div
      ><span class="sectionDescription">Synopsis: </span
      ><span class="sectionText">{{ trackedBill.Synopsis }}</span></div
    >
    <div v-if="!trackedBill.IsSummary"
      ><span class="sectionDescription">Implications: </span
      ><span class="sectionText">{{ trackedBill.Pros }}</span></div
    >
    <div v-if="!trackedBill.IsSummary"
      ><span class="sectionDescription">Specific Concerns: </span
      ><span class="sectionText">{{ trackedBill.Cons }}</span></div
    >
    <div v-if="!trackedBill.IsSummary"
      ><span class="sectionDescription">Proposed Changes: </span
      ><span class="sectionText">{{ trackedBill.ProposedChanges }}</span></div
    >
    <div
      ><span class="sectionDescription">Agency Contact: </span
      ><span
        class="sectionText"
        v-for="(contact, index) in trackedBill.Assignments"
        :key="contact.ID"
      >
        <span>
          {{
            contact.FirstName && contact.LastName
              ? contact.FirstName + ' ' + contact.LastName
              : contact.Email
          }}
          <BaseHelpTooltip
            width="500px"
            x-small
            tooltipText="contact info"
            header="Contact Details"
            icon="mdi-card-account-details"
            ><div>
              <div v-if="contact.Agency"
                ><span class="sectionDescription">Agency: </span
                ><span class="sectionText">{{ contact.Agency }}</span></div
              >
              <div v-if="contact.Division"
                ><span class="sectionDescription">Division: </span
                ><span class="sectionText">{{ contact.Division }}</span></div
              >
              <div
                ><span class="sectionDescription">Name: </span
                ><span class="sectionText"
                  >{{ contact.FirstName }} {{ contact.LastName }}</span
                ></div
              >
              <div
                ><span class="sectionDescription">Email: </span
                ><span class="sectionText"
                  ><a target="_blank" :href="`mailto:${contact.Email}`">{{
                    contact.Email
                  }}</a></span
                ></div
              >
              <div v-if="contact.OfficePhone"
                ><span class="sectionDescription">Office Phone: </span
                ><span class="sectionText">{{ contact.OfficePhone }}</span></div
              >
              <div v-if="contact.MobilePhone"
                ><span class="sectionDescription">Mobile Phone: </span
                ><span class="sectionText">{{ contact.MobilePhone }}</span></div
              >
            </div>
          </BaseHelpTooltip> </span
        ><span v-if="!index == trackedBill.Assignments.length - 1">, </span>
      </span></div
    >
    <div
      ><span class="sectionDescription">Additional Contact: </span
      ><span class="sectionText">{{ trackedBill.Contact }}</span></div
    >
    <div
      ><span class="sectionDescription">Last Updated: </span
      ><span class="sectionText">{{
        dayjs(trackedBill.LastUpdate).fromNow()
      }}</span></div
    >
    <div v-if="trackedBill.recent && !trackedBill.IsSummary">
      <span class="sectionDescription">Last Tracker Update: </span>
      <span class="sectionText" v-if="trackedBill.recent.FileName"
        ><a @click="downloadDocument(trackedBill.recent)">
          {{ trackedBill.recent.FileName }}
        </a>
        document uploaded</span
      >
      <span class="sectionText" v-if="trackedBill.recent.Note">
        <span v-if="trackedBill.recent.IsPrivate">private comment added</span>
        <span
          v-else-if="
            trackedBill.recent.Note.startsWith('![') ||
            trackedBill.recent.Note.startsWith('|') ||
            trackedBill.recent.Note.startsWith('```')
          "
          >comment added</span
        >
        <span v-else>{{ snippet(trackedBill.recent.Note) }}</span>
      </span>
      <span class="sectionText" v-if="trackedBill.recent.URL"
        ><a :href="trackedBill.recent.link" target="_blank">{{
          trackedBill.recent.Description
        }}</a>
        link added</span
      >
      <span class="sectionText">
        -<span v-if="trackedBill.recent && trackedBill.recent.CreatedBy">
          <span
            v-if="
              trackedBill.recent.CreatedBy.FirstName &&
              trackedBill.recent.CreatedBy.LastName
            "
            >{{ trackedBill.recent.CreatedBy.FirstName }}
            {{ trackedBill.recent.CreatedBy.LastName }}</span
          ><span v-else>
            {{ trackedBill.recent.CreatedBy.Email }}
          </span>
          -
          {{ trackedBill.recent.CreatedDate | formatDateTime }}
        </span>
      </span>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { authComputed } from '@state/helpers'
dayjs.extend(relativeTime)
import download from 'downloadjs'
import { get, sync, commit, call } from 'vuex-pathify'
export default {
  //model: {
  //	prop: ''
  //},
  props: {
    trackedBill: {
      type: Object,
      default: null,
    },
  },
  components: {},
  filters: {},
  data() {
    return {
      dayjs,
    }
  },
  created() {},
  computed: {
    ...authComputed,
    assignedUsers() {
      return this.trackedBill.Assignments.map((a) => {
        if (a.FirstName && a.LastName) {
          return a.FirstName + ' ' + a.LastName
        } else {
          return a.Email
        }
      }).join(', ')
    },
  },
  methods: {
    handleError: call('errors/handleError'),
    snippet(text) {
      text = text
        .toString()
        .split('\n')[0]
        .replace(/(<([^>]+)>)/gi, '')
      if (text.toString().length > 100) {
        return text.toString().substring(0, 100) + '...'
      } else {
        return text
      }
    },
    downloadDocument(doc) {
      let url
      url = `Document/Download/${doc.ID}`
      let headers = { responseType: 'blob' }
      this.$axios.get(url, headers).then(
        (res) => {
          const content = res.headers['content-type']
          const dispo = res.headers['content-disposition']
          var filename = ''
          if (dispo && dispo.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            var matches = filenameRegex.exec(dispo)
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '')
            }
          }
          download(res.data, filename, content)
        },
        (error) => {
          this.handleError(error)
          console.log(error)
        }
      )
    },
  },
  watch: {},
}
</script>
<style scoped>
.sectionDescription {
  font-weight: bold;
}
.sectionText {
  white-space: pre-wrap;
}
.critical {
  color: red;
}
.high {
  color: darkred;
}
.moderate {
  color: orange;
}
.low {
  color: gold;
}
.serious {
  color: crimson;
}
.some {
  color: orange;
}
.none {
  color: green;
}
.oppose {
  color: crimson;
}
.neutral {
  color: orange;
}
.support {
  color: green;
}
</style>
